import React from "react"


function Projects() {
    return(
        <div className="section">
        <h2>Projects</h2>

          <div className="project-item">
            <a className="flex" href="https://peelsgood.co">
                <h3>Peels Good</h3>
            </a>
            <p>I made this website using the Boost Shopify theme, with a large amount of custom Liquid code to customize the website. Additionally, I have managed to get a custom upload working for the website to allow user to do custom sticker options.</p>
        </div>

        
        <div className="project-item">
            <a className="flex" href="https://cmb-realestate.com">
                <h3>CMB-REALESTATE.COM</h3>
            </a>
            <p>This is a real estate website that I had build in Wordpress that required a custom plugin in order to properly call properties from the MLS. It was written with JavaScript and PHP along with using the principles of REST APIs.</p>
        </div>

        <div className="project-item">
            <a className="flex" href="https://github.com/SanginiusLives/Print-Tracking-Software">
                <h3>Pring Tracking Software</h3>
            </a>
            <p>A software developed in order to track what is being printed on what machine for a company that produces stickers. This software was made using Node Js for the backend, using Websockets to support live interactions from multiple connections. React and basic Javascript were used for the front end, along with a custom API.</p>
        </div>

        <div className="project-item">
            <a className="flex" href="https://hilarious-paprenjak-50974d.netlify.app">
                <h3>Youtube Analytics Software</h3>
            </a>
            <p>My capstone project for my certification. The Youtube Video Analytics app is a React JS and Node JS app designed to help content creators, as well as those generally interested, gleam what does and does not work for a youtube video. As most analytics are private, something only the video creator could see, this app takes publically available data and helps to calculate some baseline statics to see an overall performance of a given video.</p>
        </div>

        <div className="project-item">
            <a className="flex" href="https://www.peninsulatreeservice.com">
                <h3>peninsulatreeservice.com</h3>
            </a>
            <p>Designed while working for a marketing company, I had designed this website in Figma before using VSCode to build the website using Wordpress as a base. The codes used to make this website were PHP, JavaScript, HTML and Css.</p>
        </div>

</div>
    )
}

export default Projects;
